export default __webpack_public_path__ + "static/media/lendnest4.1e67bef2.png";